import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const companyInfoApiUrl = `${apiUrl}CompanyInfo`;

export const companyInfoGet = () =>
    axios.get(`${companyInfoApiUrl}`);

export const companyInfoUpdateById = (id, data) =>
    axios.put(`${companyInfoApiUrl}/${id}`, data);
